'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dragAndDropUtils = require('../../utils/dnd/dragAndDropUtils');

var _cssUtil = require('../../utils/cssUtil');

require('./ElementDragGroupPositioner.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Styles


var getTranslation = function getTranslation(props) {
    // The distance between the top of the browser and the dragged element (not the mouse pointer)
    var sourceClientOffset = props.sourceClientOffset,
        clientOffset = props.clientOffset,
        item = props.item;


    if (!sourceClientOffset) return { display: 'none' };
    var offset = (0, _dragAndDropUtils.isNewElement)({ item: item }) ? clientOffset : sourceClientOffset;

    return (0, _cssUtil.getTranslationStyles)(offset);
};

var ElementDragGroupPositioner = function (_React$Component) {
    _inherits(ElementDragGroupPositioner, _React$Component);

    function ElementDragGroupPositioner() {
        _classCallCheck(this, ElementDragGroupPositioner);

        return _possibleConstructorReturn(this, (ElementDragGroupPositioner.__proto__ || Object.getPrototypeOf(ElementDragGroupPositioner)).apply(this, arguments));
    }

    _createClass(ElementDragGroupPositioner, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.clientOffset !== this.props.clientOffset;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ElementDragGroupPositioner ' + this.props.hoveredTypes, style: getTranslation(this.props) },
                _react2.default.createElement(
                    'div',
                    { className: 'hover-transform-target' },
                    this.props.children
                )
            );
        }
    }]);

    return ElementDragGroupPositioner;
}(_react2.default.Component);

ElementDragGroupPositioner.propTypes = {
    sourceClientOffset: _propTypes2.default.object,
    clientOffset: _propTypes2.default.object,
    hoveredTypes: _propTypes2.default.array,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = ElementDragGroupPositioner;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/ElementDragGroupPositioner.js
// module id = 1967
// module chunks = 0